import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
}) export class CRSFtokenInterceptor implements HttpInterceptor {

    constructor() { }

    intercept(
      request: HttpRequest<any>,
      next: HttpHandler
    ): Observable<HttpEvent<any>> {
      
      if (this.neededXSRFToken(request)) {
        
        const csrfToken = this.getToken();

        if(!request.url.includes("/"+ environment.keycloak.context +"/") && !!csrfToken) {
          request = request.clone({
            setHeaders: { 'X-XSRF-TOKEN': csrfToken }
          });
        }

      }
      return next.handle(request);

    }


    private getToken() {
      //return new Date().getTime()%5 === 0 ? 'aaa' : this.getCookies()['XSRF-TOKEN'];
      return this.getCookies()['XSRF-TOKEN'];
    }


    private getCookies = () =>
      document.cookie.split('; ').reduce((acc, value) => {
        const cookie = value.split('=');
        acc[cookie[0]] = cookie[1];
        return acc;
      }, {});


    private neededXSRFToken(request: HttpRequest<any>) {
      return request.method === 'POST' ||
        request.method === 'PUT' ||
        request.method === 'DELETE';
    }

}
